import { computed, defineComponent } from "vue";
import ProgressBar from "@com/components/progress-bar/index.vue";
import { getTypesByExtension, utilsIcon } from "@pt/views/pt-entry/creative-assets/media/config";
import { getFileExtension } from "@com/utils/file";
export default defineComponent({
    components: {
        ProgressBar: ProgressBar
    },
    props: {
        file: {
            type: Object,
            required: true
        }
    },
    setup: function setup(props) {
        var progressBarAttrs = {
            size: "small",
            bgColor: "#ddd",
            barColor: "#F3C547",
            barBorderRadius: 6
        };
        var icon = computed(function() {
            return utilsIcon[getTypesByExtension(getFileExtension(props.file.name))] || "";
        });
        var isSuccessStatus = computed(function() {
            return props.file.status === "success";
        });
        var isErrorStatus = computed(function() {
            return props.file.status === "error";
        });
        var isFileUploadingStatus = computed(function() {
            return props.file.status === "uploading";
        });
        var handleCancel = function() {
            console.log("cancel");
        };
        return {
            icon: icon,
            progressBarAttrs: progressBarAttrs,
            isSuccessStatus: isSuccessStatus,
            isErrorStatus: isErrorStatus,
            isFileUploadingStatus: isFileUploadingStatus,
            handleCancel: handleCancel
        };
    }
});
